<template>
    <div class="sbs-select-list">
        <div class="sbs-select-list__content">
            <!-- @slot Слот по-умолчанию для компонентов `SbsSelectListItem` -->
            <slot></slot>
        </div>
    </div>
</template>

<script>
/**
 * Компонент для группы `SbsSelectListItem`.
 */
export default {
    name: 'SbsSelectList',
    provide() {
        return {
            listItemGroupComponent: this,
        };
    },
    emits: ['update:modelValue', 'change'],
    computed: {
        isMultiple() {
            return Array.isArray(this.modelValue);
        },
    },
    methods: {
        listItemChangeHandler(value) {
            /**
             * Событие `update:modelValue` срабатывает при изменении значения группы элементов списка.
             * В качестве параметра - значение после изменения
             */
            this.$emit('update:modelValue', value);
            this.$emit('change', value);
        },
    },
    props: {
        /**
         * Перевод в неактивное состояние
         */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Скрывает элемент управления
         */
        hideControl: {
            type: Boolean,
            default: false,
        },
        /**
         * Включает принудительный выбор элемента
         */
        mandatory: {
            type: Boolean,
            default: false,
        },
        /**
         * Название элемента списка, используется для объединения в общую группу
         */
        name: {
            type: String,
            default: '',
        },
        /**
         * Текущий выбранный элемент списка
         * @model
         */
        modelValue: {
            type: [String, Array],
            default: '',
        },
    },
};
</script>

<style lang="scss">
.sbs-select-list {
    display: flex;
    flex-direction: column;

    &__content {
        display: flex;
        flex-direction: column;
    }
}
</style>
